import { useEffect, useRef, useState } from "react";
import type { U2000SearchParameter } from "../../reducer/formReducer/U2000SearchState";
import { extractBaseLanguage } from "../../tools/U2000LanguageUtils";

export interface U2000ExportExcelHandlersParams {
  doExportExcelFn: (filter: U2000SearchParameter, lang: "fr" | "en") => Promise<any>;
  i18nLanguage: string;
  onSuccess?: (processId: string) => void;
  onError?: (errors: { error: any }) => void;
}

export interface U2000ExportExcelHandlersReturn {
  handleExportExcel: (filter: U2000SearchParameter) => Promise<void>;
  isExporting: boolean;
}

export function useU2000ExportExcelHandlers({ doExportExcelFn, i18nLanguage, onSuccess, onError }: U2000ExportExcelHandlersParams): U2000ExportExcelHandlersReturn {
  const [isExporting, setIsExporting] = useState(false);
  const isExportingRef = useRef(false);

  // Synchroniser la ref avec l'état
  useEffect(() => {
    isExportingRef.current = isExporting;
  }, [isExporting]);

  const handleExportExcel = async (filter: U2000SearchParameter) => {
    if (isExportingRef.current) return; // Éviter les appels multiples

    try {
      setIsExporting(true);
      // Extraire la langue de base (fr ou en) depuis i18n.language
      const lang = extractBaseLanguage(i18nLanguage);
      const response = await doExportExcelFn(filter, lang);
      const processId = response.data.processId || response.data.id;

      if (onSuccess) {
        onSuccess(processId);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    } finally {
      setIsExporting(false);
    }
  };

  return { handleExportExcel, isExporting };
}
